export default "__VITE_ASSET__DLO4HjhG__"